const ItemPackageLockers = ({ item }) => (
  <tr className="border-b border-border/60 transition-colors last:border-0 hover:bg-accent/40">
    <td className="px-3 py-2 text-right text-[13px] font-medium tabular-nums text-foreground">
      {item.CantPaquetes}
    </td>
    <td className="max-w-[18rem] truncate px-3 py-2 text-[13px] text-muted-foreground">
      {item.Plataforma}
    </td>
  </tr>
);

export default ItemPackageLockers;
